// section-head.tsx
//
// The Competitive Intelligence section header. Shared because the two blocks it
// headed now live on different pages: "Recommendation ranking" stayed on Brand
// Monitoring, "Attribute rankings" moved to the Deep Signal Competitive tab.
// One copy, so the eyebrow and title scale cannot drift apart between them.
export function SectionHead({ title, onInfo, right, className = "" }: {
  title: string; onInfo?: () => void; right?: React.ReactNode; className?: string;
}) {
  return (
    <div className={`ci-head ${className}`}>
      <div>
        <div className="ci-eyebrow">Competitive intelligence</div>
        <div className="ci-title-row">
          <h3>{title}</h3>
          {onInfo && <button type="button" className="ci-q" onClick={onInfo}>?</button>}
        </div>
      </div>
      {right && <div className="ci-head-right">{right}</div>}
    </div>
  );
}
